function homepage() {
	const mainHomepage = document.querySelector('main.homepage');
	if (!mainHomepage) return;

	const heroSwiper = new Swiper('.swiper-hero', {
		slidesPerView: 1,
		spaceBetween: 20,
		autoHeight: true,
		navigation: {
			nextEl: '.hero .swiper-button-next',
			prevEl: '.hero .swiper-button-prev',
		},
	});

	const reportsSwiper = new Swiper('.swiper-reports', {
		slidesPerView: 1,
		spaceBetween: 40,
		observer: true,
		observeParents: true,
		navigation: {
			nextEl: '.stock-reports .swiper-button-next',
			prevEl: '.stock-reports .swiper-button-prev',
		},
		breakpoints: {
			992: {
				slidesPerView: 3,
			},
			576: {
				slidesPerView: 2,
			},
		},
	});

	const newsSwiper = new Swiper('.swiper-news', {
		slidesPerView: 1,
		spaceBetween: 40,
		autoHeight: true,
		observer: true,
		observeParents: true,
		navigation: {
			nextEl: '.news .swiper-button-next',
			prevEl: '.news .swiper-button-prev',
		},
		breakpoints: {
			992: {
				slidesPerView: 3,
			},
			576: {
				slidesPerView: 2,
			},
		},
	});

	$('.animate-after').addClass('animate');

	$('.stock-reports .reports-nav button').on('click', function () {
		const numbersId = $(this).attr('data-id');

		$(this).addClass('active');
		$(this).closest('li').siblings().find('button').removeClass('active');

		$(this).attr('aria-pressed', 'true');
		$(this).closest('li').siblings().find('button').attr('aria-pressed', 'false');

		$('.stock-reports .reports').slideUp();
		$('.stock-reports #reports-' + numbersId).slideDown();
	});

	$('.results .results-nav button').on('click', function () {
		const numbersId = $(this).attr('data-id');

		$(this).addClass('active');
		$(this).closest('li').siblings().find('button').removeClass('active');

		$(this).attr('aria-pressed', 'true');
		$(this).closest('li').siblings().find('button').attr('aria-pressed', 'false');

		$('.results .results-numbers').slideUp();
		$('.results #results-numbers-' + numbersId).slideDown();
	});

	// activateShuffleOnVisible('.fh-shuffle', '.homepage .results', 750);
	// activateShuffleOnVisible('.fh-shuffle', '.homepage .dividend', 750);

	// gsap.to('.hero-image-img', {
	// 	scale: 1.25,
	// 	ease: 'none',
	// 	scrollTrigger: {
	// 		trigger: '.hero',
	// 		start: 'top top',
	// 		end: 'bottom top',
	// 		scrub: true,
	// 	},
	// });

	if (window.matchMedia('(min-width: 576px)').matches) {
		gsap.to('.hero-image svg', {
			y: -200,
			ease: 'none',
			scrollTrigger: {
				trigger: '.hero',
				start: 'top top',
				end: 'bottom top',
				scrub: true,
			},
		});
	} else {
		gsap.to('.hero-image svg', {
			marginTop: -100,
			ease: 'none',
			scrollTrigger: {
				trigger: '.hero',
				start: 'top top',
				end: 'bottom top',
				scrub: true,
			},
		});
	}

	// document.querySelectorAll('.section-top').forEach((section, index) => {
	// 	const image = section.querySelector('.section-top-image-img');
	//
	// 	if (image && !image.classList.contains('no-scale')) {
	// 		gsap.to(image, {
	// 			scale: 1.25,
	// 			ease: 'none',
	// 			scrollTrigger: {
	// 				trigger: section,
	// 				start: 'top bottom',
	// 				end: 'top top',
	// 				scrub: true,
	// 			},
	// 		});
	// 	}
	// });

	// document.querySelectorAll('.section-top').forEach((section, index) => {
	// 	const svg = section.querySelector('svg');
	//
	// 	let marginTop = window.matchMedia('(min-width: 768px)').matches ? -50 : -100;
	//
	// 	if (svg) {
	// 		gsap.to(svg, {
	// 			marginTop: marginTop,
	// 			ease: 'none',
	// 			scrollTrigger: {
	// 				trigger: svg,
	// 				start: 'top bottom',
	// 				end: 'top top',
	// 				scrub: true,
	// 			},
	// 		});
	// 	}
	// });

	// Initialize calendar event buttons (Google Calendar and Outlook)
	initCalendarButtons();
}
